var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 78,
    viewBox: "0 0 99 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.7904 13.3817C31.7904 13.3817 31.6954 10.4967 31.8204 8.73175C31.9704 6.59675 32.9454 1.74175 37.4554 1.95175C39.9704 1.74175 61.9454 1.75175 63.9854 2.44675C67.0254 2.89675 68.5404 4.72675 68.6404 7.09175C68.7304 9.12175 68.7004 11.6567 68.7054 13.6867",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.8407 14.0115C35.8407 14.0115 35.7557 12.9415 35.8807 11.1815C36.0307 9.04652 35.1607 5.32152 39.6707 5.53152C42.1857 5.32152 59.9557 5.21152 61.9957 5.90652C64.5757 6.77152 64.2457 8.18652 64.3407 10.5515C64.4307 12.5815 64.4007 11.8815 64.4057 13.9065",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.2705 17.0763C29.2955 16.9013 29.3205 16.7263 29.3655 16.5663C29.5805 15.8163 30.1005 13.4863 32.5405 13.4863C34.5855 13.4863 36.9855 14.4713 37.2205 17.1813",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M71.6857 17.247C45.0457 17.262 37.0607 17.302 29.9357 17.077C28.6257 17.072 19.1557 16.947 17.8457 16.942C17.8457 16.942 13.1607 16.502 13.1607 20.747C13.1607 24.992 13.0157 27.177 13.0157 27.177C13.2857 39.252 13.2057 53.212 12.7707 65.282C12.6807 67.832 14.5657 67.617 17.0957 67.752C31.1007 67.972 44.9957 68.312 59.0007 68.482L79.1657 68.607C79.1657 68.607 84.9357 68.307 84.7957 63.082C84.4557 49.297 84.4007 34.327 84.6557 20.552C84.6757 19.257 83.9107 17.167 81.2107 17.302C78.0407 17.292 74.8557 17.282 71.6857 17.257C70.5957 15.682 69.6207 13.652 66.5157 13.692C62.4657 13.742 61.8007 17.272 61.8007 17.272",
    stroke: "#EF7056",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.521 10.3519L10.291 5.21191",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M7.16074 18.2316L0.510742 17.5566",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.22582 13.1769L3.21582 10.6719",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M87.4961 72.3115L90.3661 77.1665",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M91.8057 63.6819L98.4907 63.4619",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M91.3955 68.9014L96.6905 70.7364",
    stroke: "#EF7056",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.49d49c60be928d2f24fe09b7a385e7f4.svg";
export { ForwardRef as ReactComponent };